import React from 'react'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'

import { appAuthRoutes } from '../common/appRoutes'

import { LoginScreen } from './LoginScreen'
import { RegisterScreen } from './RegisterScreen'
import { PasswordResetScreen } from './PasswordResetScreen'
import { MoySkladAppAuthScreen } from './MoySkladAppAuthScreen'

export const AppAuthRouter = () =>
  <div className="App">
    <BrowserRouter>
      <Switch>
        <Route path={appAuthRoutes.Login}>
          <LoginScreen/>
        </Route>

        <Route path={appAuthRoutes.Register}>
          <RegisterScreen/>
        </Route>

        <Route path={appAuthRoutes.PasswordReset}>
          <PasswordResetScreen/>
        </Route>

        <Route path={appAuthRoutes.MoySkladApp.template}>
          <MoySkladAppAuthScreen/>
        </Route>

        <Route path={appAuthRoutes.MoySkladAppOld}>
          {/* Don't redirect - there are query params needed for auth */}
          <MoySkladAppAuthScreen/>
        </Route>

        {/* NOTE: Fallback route, must remain the last one */}
        <Route path="*">
          <Redirect to={appAuthRoutes.Login}/>
        </Route>
      </Switch>
    </BrowserRouter>
  </div>